import api from '../api'

export const postModule = (params) => api.post('/admin/modules', params)

export const putModule = (params) => api.put(`/admin/modules/${ params.id }`, params)

export const deleteModule = (params) => api.delete(`/admin/modules/${ params.id }`)

export const attachModuleApplication = (params) => api.post(`/admin/functionalities/${ params.moduleId }`, params)

export const detachModuleApplication = (params) => api.patch('/admin/functionalities/modules/dissociate', params)
